import styled from "styled-components";

export const ModelMatrixWrapper = styled.div`
  width: 100%;
`;
